import { render, staticRenderFns } from "./TheSettingsFoundationsCategories.vue?vue&type=template&id=1320e11a&"
import script from "./TheSettingsFoundationsCategories.vue?vue&type=script&lang=js&"
export * from "./TheSettingsFoundationsCategories.vue?vue&type=script&lang=js&"
import style0 from "./TheSettingsFoundationsCategories.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports